import { ComponentProps } from 'react';
import { CheckIcon } from 'lucide-react';
import { motion } from 'motion/react';

import { cn } from '@components/primitives/utilities';

import css from './styles.module.css';

const MotionCheckIcon = motion.create(CheckIcon);

export function Check(props: ComponentProps<typeof MotionCheckIcon>) {
  return (
    <MotionCheckIcon
      {...props}
      className={cn(css.check, props.className)}
      variants={{
        from: {
          '--animated-check-progress': 0,
        },
        to: {
          '--animated-check-progress': 1,
        },
      }}
      aria-hidden
    />
  );
}
